import useUIBp from "../../../Hooks/useUIBoilerplate";
import generateC365ScanReport from "../../Reports/Actions/c365ScanErrors";
import GenericConfirmation2 from "./AllPurpose2/DialogConfirmation";

const MixedC365ReportWarningConfirmation = () => {
  const { auth, dispatch, settings, UI } = useUIBp();
  const locale = settings.locale;
  const payload = UI.modal2.payload ?? { };
  const { selected, scans } = payload;

  const UIText = {
    "es-CL": {
      header: "La petición tiene una mezcla de equipos Cloner365 y no-Cloner365!",
      message: `La lista de usuarios seleccionados contiene una mezcla de equipos Cloner365 (${scans.length}) y otros que no caen en esta categoría (${selected.length-scans.length}). El reporte de escaneo se generará considerando exclusivamente los equipos Cloner365`,
    },
    "en-US": {
      header: "The request has a mix of Cloner365 and non-Cloner365 machines!",
      message: `The selected user list contains a mix of Cloner365 (${scans.length}) and other machines that do not fall into this category (${selected.length-scans.length}). The scan report will be generated considering only the Cloner365 machines`,
    },
  };
  const { header, message } = UIText[locale];

  const confirmation = () => {
    dispatch(generateC365ScanReport({ ...auth, scans, locale }));
  };

  return (
    <GenericConfirmation2
      {...{ header, message, severity: "warning", confirmation }}
    />
  );
};

export default MixedC365ReportWarningConfirmation;
